import React, { useState, useEffect } from "react";
import {
  getAllowedEmails,
  addAllowedEmail,
  removeAllowedEmail,
} from "../firebase";
import "./Emails.css";

const Emails: React.FC = () => {
  const [emails, setEmails] = useState<{ [key: string]: boolean }>({});
  const [newEmail, setNewEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadEmails();
  }, []);

  const loadEmails = async () => {
    const allowedEmails = await getAllowedEmails();
    setEmails(allowedEmails);
  };

  const handleAddEmail = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newEmail) return;

    setLoading(true);
    setMessage("");

    try {
      const fullEmail = newEmail.includes("@")
        ? newEmail
        : `${newEmail}@gmail.com`;
      await addAllowedEmail(fullEmail);
      setNewEmail("");
      await loadEmails();
      setMessage("이메일이 추가되었습니다.");
    } catch (error) {
      setMessage(`이메일 추가 중 오류가 발생했습니다: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveEmail = async (email: string) => {
    try {
      await removeAllowedEmail(email);
      await loadEmails();
      setMessage("이메일이 제거되었습니다.");
    } catch (error) {
      setMessage(`이메일 제거 중 오류가 발생했습니다: ${error}`);
    }
  };

  return (
    <div className="emails-container">
      <div className="content-header">
        <h2>이메일 관리</h2>
      </div>

      <div className="emails-content">
        <div className="email-form-section">
          <h3>새 이메일 추가</h3>
          <form onSubmit={handleAddEmail} className="email-form">
            <div className="form-group">
              <label htmlFor="email">
                이메일 주소 (@gmail.com이 없는 경우 자동으로 추가됩니다)
              </label>
              <div className="input-group">
                <input
                  type="text"
                  id="email"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  placeholder="example"
                  required
                />
                <button type="submit" disabled={loading}>
                  {loading ? "추가 중..." : "추가"}
                </button>
              </div>
              <small>예: example 또는 example@gmail.com</small>
            </div>
          </form>

          {message && <div className="message">{message}</div>}
        </div>

        <div className="email-list-section">
          <h3>허용된 이메일 목록</h3>
          {Object.keys(emails).length === 0 ? (
            <p className="no-emails">등록된 이메일이 없습니다.</p>
          ) : (
            <div className="email-list">
              {Object.keys(emails).map((email) => (
                <div key={email} className="email-item">
                  <span className="email-address">{email}</span>
                  <button
                    onClick={() => handleRemoveEmail(email)}
                    className="remove-button"
                  >
                    제거
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Emails;
